import { useNavigate } from 'react-router-dom';
import { EllipsisVertical, Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Badge } from '@/components/ui/badge';
import { TableCell, TableRow } from '@/components/ui/table';
import { convertToDateFormat } from '@/helpers/dateHelpers';

const UserRow = ({ user }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/user/${user.id}`);
  };

  return (
    <>
      <TableRow onClick={handleRowClick} className="cursor-pointer">
        <TableCell className="py-2">
          {user.firstname} {user.lastname}
        </TableCell>
        <TableCell className="py-2">{user.email}</TableCell>
        <TableCell className="py-2">
          {user.coach && <Badge>Coach</Badge>}
        </TableCell>
        <TableCell className="py-2">
          {convertToDateFormat(user.createdAt)}
        </TableCell>
        <TableCell className="py-2" />
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
              <DropdownMenuLabel>
                {user.firstname} {user.lastname}
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Pencil className="mr-2 h-4 w-4" />
                Edit User
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
    </>
  );
};

export default UserRow;
